import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Car, Users, ClipboardList, Plus } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission, user } = useAuth();

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const navItems = [
    { 
      path: '/', 
      icon: Home, 
      label: 'Accueil',
      permission: 'dashboard' as const,
    },
    { 
      path: '/vehicules', 
      icon: Car, 
      label: 'Véhicules',
      permission: 'vehicles' as const,
    },
    { 
      path: '/assignments/new', 
      icon: Plus, 
      label: 'Nouveau',
      permission: 'assignments' as const,
      isMain: true,
    },
    { 
      path: '/chauffeurs', 
      icon: Users, 
      label: 'Chauffeurs',
      permission: 'drivers' as const,
    },
    { 
      path: '/assignments', 
      icon: ClipboardList, 
      label: 'Missions',
      permission: 'assignments' as const,
    },
  ];

  // Filtrer les éléments selon les permissions
  const visibleItems = navItems.filter(item => 
    user?.isSuperAdmin || hasPermission(item.permission, 'read')
  );

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg sm:hidden safe-area-inset-bottom">
      <div className="flex items-center justify-around h-16">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          if (item.isMain) {
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="flex items-center justify-center w-14 h-14 -mt-6 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full shadow-lg active:scale-95 transition-transform"
              >
                <Icon className="w-7 h-7 text-white" />
              </button>
            );
          }
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center flex-1 py-2 transition-colors ${
                active ? 'text-blue-600' : 'text-gray-500'
              }`}
            >
              <Icon className={`w-5 h-5 ${active ? 'text-blue-600' : 'text-gray-400'}`} />
              <span className={`text-xs mt-0.5 ${active ? 'font-medium' : ''}`}>
                {item.label}
              </span>
              {active && (
                <div className="absolute bottom-0 w-8 h-0.5 bg-blue-600 rounded-full" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;







